import { render, staticRenderFns } from "./BasicCashupForm.vue?vue&type=template&id=4ec3a90c&scoped=true"
import script from "./BasicCashupForm.vue?vue&type=script&lang=js"
export * from "./BasicCashupForm.vue?vue&type=script&lang=js"
import style0 from "./BasicCashupForm.vue?vue&type=style&index=0&id=4ec3a90c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3a90c",
  null
  
)

export default component.exports